import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

// `success-subtle` is a quieter success tag for a property beside a status tag, such as Required
// next to Bound, so the two do not compete.
export type TagState =
  | 'success'
  | 'success-subtle'
  | 'warning'
  | 'attention'
  | 'error'
  | 'info'
  | 'neutral';

@Component({
  selector: 'xemex-tag',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './tag.component.scss',
  template: `
    <span class="tag" [attr.data-state]="state()">
      @if (icon()) {
        <mat-icon class="tag__icon">{{ icon() }}</mat-icon>
      }
      <span class="tag__label">{{ label() }}</span>
    </span>
  `,
})
export class TagComponent {
  state = input.required<TagState>();
  label = input.required<string>();
  /** Optional leading Material Symbols icon name, e.g. `lock`. */
  icon = input<string>();
}
